export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function exhaustiveGuard(_: never): never {
  throw new Error('Not handled switch case')
}
